<template>
    <div class="about-div">
        <div class="col-lg-12 px-2">
            <div class="about-title mb-2 dn-mb">News &amp; Insight</div>
            <div class="about-text dn-mb">Get the latest news and updates on real estate industry</div>

            <div class="my-4 blog-category-wrapper uni-max-md">
                <a 
                    v-for="(cat, i) in categories"
                    :key="i"
                    class="blog-category-btn"
                    :class="{ 'active': active.id == cat.id }"
                    :href="`/news-and-insight/${cat.slug}`"
                >
                    {{ cat.name }}
                </a>
            </div>

            <div v-if="filtered.length" class="d-flex flex-wrap uni-max-md">
                <a v-for="(u, i) in filtered" :href="'/news-and-insight/' + active.slug + '/' + u.slug" class="blog-card" :key="i">
                    <div class="w-100 pb-3">
                        <img :src="u.featured_photo.medium.url" alt="shijie" width="100%" height="200px" style="object-fit: cover;border-radius: 5px" />
                    </div>
                    <div class="about-title m-0 px-3">{{ u.title }}</div>
                    <div class="about-text p-3"><small>{{ parseDate(u.date) }}</small></div>
                </a>
            </div>
            <div v-else class="text-center my-5">No Blog Found</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "blogs-filter",
        props: ['blogs', 'categories', 'active'],
        data() {
            return {
                rows: [],
            };
        },
        computed: {
            filtered() {
                const allBlogs = this.blogs;
                const sorted = allBlogs.filter(u => {
                    if (this.categories.length) {
                        return u.blog_category_id == this.active?.id
                    } else {
                        return true
                    }
                });
                return sorted
            }
        },
        methods: {
            addComma: function (num) {
                var num_parts = num.toString().split(".");
                num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return num_parts.join(".");
            },
            parseDate: function(str) {
                var d = new Date(str.split('T')[0]);
                var ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
                var mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(d);
                var da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
                var date = mo + ' ' + da + ', ' + ye;

                return date;
            },
        }
    };
</script>